import React, { Component } from "react";
import * as API from "../../api.js";
import {
  checkSubscriptionAndStorage,
  getLocalStorageValue,
} from "../../ReusableComponents/reusableFunctions";
import SideBarNew from "../../SideBarNew";
import { activesubscription } from "../../redux";
import { connect,useSelector } from "react-redux";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import {
  addUserAnalytic,
  updateOutTime,
} from "../../ReusableComponents/reusableFunctions";
import AppConstants from "../../AppConstants";
import { getActiveTeam } from "../../Teams";
import { ManageProjectAccess } from "../../Teams/ManageProjectAccess";
import Noproject from "../../assets/Images/Noproject.png";
import TopBarNew from "../../TopBarNew.js";
import TowerIcon from "../../icons/TowerIcon.svg";
import TransTowerIcon from "../../icons/TransTowerIcon.svg";
import UpGraphIcon from "../../icons/UpGraphIcon.svg";
import DownGraphIcon from "../../icons/DownGraphIcon.svg";
import YellowGraphIcon from "../../icons/YellowGraphIcon.svg";
import { Circle } from "rc-progress";
import MenuIcon from "../../icons/MenuIcon.svg";
import TowerIcon2 from "../../icons/TowerIcon2.svg";
import { TowerLocations } from "./TowerLocations.js";
import RecentTowers from "./RecentTowers.js";
import { Link } from "react-router-dom";
import service from "../../sidebaricon/Services.png";

class AeroCaptureDashboard extends Component {
  state = {
    user: {},
    type: "",
    selectedAllItems: "projects",
    key: " ",
    progress: 0,
    pageSize: 25,
    currentpage: -1,
    taskPage: 0,
    firstpage: 1,
    counts: 0,
    showDownloadPopup: false,
    projectRenamePopup: false,
    loader: true,
    taskStatusCount: {},
    services: [],
    projects: [],
    tasks: [],
    reports: [],
    taskCount: 0,
    showBackIcon: true,
    cancel: false,
    loadingMain: true,
    sidebarMode: this.props.location.state
      ? this.props.location.state.sidebarMode
      : "shrunk",
    showDeletePopup: false,
    allData: [],
    deleteItemType: "",
    deleteLoader: true,
    infoPopup: false,
    thumbURLs: [],
    projectThumbURL: [],
    recentMaps: [],
    mapsThumbURLs: [],
    recentData: [],
    loadingRecent: true,
    selected: 0,
    gridView: false,
    gridData: [],
    itemName: "",
    showProcessPopup: false,
    processPopupIcon: "",
    processAction: "",
    processMessage: "",
    noContentMsg: "No Projects Available",
    noContentImg: Noproject,
    hasMoreItems: true,
    selectedMapCollectionId: "",
    selectedCollectionId: "",
    currentStep: 0,
    createTaskMsg: "",
    collection_id: "",
    collection_name: "",
    project_name: "",
    plan_name: "",
    imageCount: 0,
    taskType: null,
    showAddTaskPopup: false,
    addDetectionTaskPopup: false,
    addAnnotationTaskPopup: false,
    videoTask: false,
    task_name: "",
    video_id: "",
    fps: 1,
    media_name: null,
    media_id: null,
    scrollHeight: "115px",
    collections: [],
    videos: [],
    selectedProject: -1,
    selectedPlan: -1,
    selectedProjectId: null,
    selectedPlanId: null,
    projectsData: [],
    imageCollectionsData: [],
    loadingPopupData: false,
    sortType: "Last Modified",
    loadingPopupData: false,
    sortTypeName: false,
    sortTypeDate: false,
    addTrainingTaskPopup: false,
    accuracy: "",
    classes: [],
    imageCount: 0,
    dataCount: 0,
    storageUsage: 0,
    objectCount: 0,
    detectorCount: 0,
    graphData: [],
    chartData: "",
    pieData: "",
    outId: "",
    taskAnalysis: "",
    redirectToReportPage: false,
    redirectToTaskPage: false,
    selectedItem: "projects",
    statLoading: true,
    graphLoading: true,
    pieLoading: true,
    unProcessedCollections: [],
    redirectToTaskPage: false,
    redirectTaskId: "",
    collectionIdSelected: "",
    projectNameSelected: "",
    projectIdSelected: "",
    task: "",
    selectedTaskType: 0,
    yTicks: {
      padding: 7,
      fill: "black",
      display: true,
      fontSize: 11,
      fontFamily: "Poppins",
      beginAtZero: true,
      fontStyle: "normal",
      fontColor: "#666666",
    },
    classArray: [],
    classError: "",
    class: "",
    messageColor: false,
    taskPurpose: "Counting",
    showDataLoader: true,
    tableHeaders: [],
    showTourPopup: false,
    showTour: false,
    runTour: false,
    tourSteps: [
      {
        disableBeacon: true,
        target: "#stat-div",
        content: (
          <div style={AppConstants.TEXTSTYLING}>
            <p>Here you will get all data processing statistics</p>
          </div>
        ),
        title: (
          <div style={AppConstants.TITLESTYLING}>Processing Statistics</div>
        ),
        placement: "right",
        styles: {
          options: {
            width: 250,
          },
        },
      },
    ],
    newProjectName: "",
    selectedMangeAccessProject: false,
    selectedProjectData: undefined,
    showSubscriptionExpirePopup: false,
    defects: {},
    monitoring: {},
    towersStatusCount: {},
    severityFormated: {},
    severity: {},
  };
  
  prev = () => {
    let selected = this.state.selected - 2 < 0 ? 0 : this.state.selected - 2;
    this.setState((state) => ({
      ...state,
      selected: selected,
    }));
    document.getElementById("scroll-div").scrollLeft -= 400;
  };

  componentWillUnmount() {
    updateOutTime(this.state.outId);
    localStorage.removeItem("created_task");
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedAllItems !== this.state.selectedAllItems) {
      this.setState((state) => ({
        ...state,
        currentpage: -1,
        taskPage: 0,
      }));
    }
  }

  componentWillMount() {
    
    document.title = "PicStork - Dashboard";
    ChartJS.register(
      BarElement,
      CategoryScale,
      ArcElement,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend,
      Filler
    );

    getActiveTeam().then((activeTeam) => {
      this.setState(
        {
          activeTeam,
        },
        () => {
          checkSubscriptionAndStorage(AppConstants.SERVICES.PICSTORK).then(
            (data) => {
              if (
                data.error ||
                data.storageExceed ||
                data.isExpired ||
                !data.isValidStoragePlan
              )
                this.setState({
                  showSubscriptionExpirePopup: {
                    ...data,
                    user: this.props?.location?.state?.user,
                  },
                });
              else {
                this.setState({
                  showSubscriptionExpirePopup: false,
                  infoPopup: true,
                });
                if (getLocalStorageValue("picstorkDashboardTour") == null)
                  this.setState({ showTourPopup: true });
              }
            }
          );

          addUserAnalytic(this.props.location.pathname).then((id) => {
            this.setState((state) => ({
              outId: id,
            }));
          });

          var style = document.createElement("style");
          style.type = "text/css";
          style.innerHTML = ".popup-content { width: 30% !important; }";
          document.getElementsByTagName("head")[0].appendChild(style);
          const COLORS = [
            "#01B574",
            "#322FC8",
            "#E73F76",
            "#FFB547",
            "#36A2EB",
          ];

          if (this.props.location.state) {
            let { user, type, sidebarMode } = this.props.location.state;
            let persistedRoot = localStorage.getItem("persist:root");
            if (persistedRoot) {
              const parsedRoot = JSON.parse(persistedRoot);
              persistedRoot = JSON.parse(parsedRoot.profile);
              this.setState((state) => ({
                ...state,
                user: persistedRoot.user,
              }));
            }

            API.getTransmissonMonitoringStats().then((monitoring) => {
              this.setState((state) => ({
                ...state,
                monitoring: monitoring.progressMonitorStats,
              }));
            });
            API.getTransmissonDashboardStats(persistedRoot.user.userid)
              .then((res) => {
                const defectsData = {
                  labels: res.data.objectCounts.map(
                    (obj) =>
                      obj.objectType.charAt(0).toUpperCase() +
                      obj.objectType.slice(1) // capitalize
                  ),
                  datasets: [
                    {
                      data: res.data.objectCounts.map((obj) => obj.count),
                      backgroundColor: res.data.objectCounts.map(
                        (_, i) => COLORS[i % COLORS.length]
                      ),
                      borderWidth: 0,
                    },
                  ],
                };
                const severitySum = res.severitySum[0]?.detections.reduce(
                  (acc, det) => {
                    for (const key of ["1", "2", "3"]) {
                      acc[key] =
                        (acc[key] || 0) + (det.severityCounts[key] || 0);
                    }
                    return acc;
                  },
                  {}
                );

                const severityData = {
                  labels: ["Low", "Medium", "High"],
                  datasets: [
                    {
                      data: [
                        severitySum["1"],
                        severitySum["2"],
                        severitySum["3"],
                      ],
                      backgroundColor: ["#01B574", "#322FC8", "#E73F76"],
                      borderWidth: 0,
                    },
                  ],
                };
                this.setState((state) => ({
                  ...state,
                  defects: defectsData,
                  severityFormated: severityData,
                  severity: res.severitySum[0],
                }));
              })
              .catch((err) => {
                console.log("err", err);
              });
            this.setState(
              (state) => ({
                ...state,
                user,
                sidebarMode,
              }),
              async () => {
                this.setState({
                  graphLoading: false,
                  pieLoading: false,
                  statLoading: false,
                });

                API.getPlanStatusCount(null)
                  .then((statusCounts) => {
                    this.setState({
                      towersStatusCount: {
                        total_installed: statusCounts.total,
                        completed_towers: statusCounts.completed,
                        in_progress_towers: statusCounts.in_progress,
                        pending_towers: statusCounts.pending,
                        installation_complete_percentage:
                          statusCounts.completion_percentage,
                      },
                    });
                  })
                  .catch((err) => {
                    console.error("Error fetching plan status counts:", err);
                  });

                API.getUserSubbedServices().then((response) => {
                  let services = response[0];
                  if (
                    services.length == 1 &&
                    services[0].title == "AeroStream"
                  ) {
                    this.setState((state) => ({
                      ...state,
                      showBackIcon: false,
                    }));
                  } else {
                    this.setState((state) => ({
                      ...state,
                      showBackIcon: true,
                    }));
                  }
                });
              }
            );
          } else {
            API.getUserType().then(
              ([blah, type, user]) => {
                console.log(user);
                this.setState((state) => ({
                  ...state,
                  user,
                  type,
                }));
              },
              (e) => {
                window.location.replace("/login");
              }
            );
          }
        }
      );
    });
  }

  render() {
    let { user, type, showBackIcon } = this.state;
    let sidebarConfigurations = {
      options:
        showBackIcon == true
          ? [
            {
              icon: service,
              text: "Services",
              path: "/",
            },
            {
              icon: TowerIcon2,
              text: "Projects",
              path: "/picstork/towers",
            },
          ]
          : null,
      user,
      type,
      mode: this.state.sidebarMode,
      picStorkHelp: true,
    };

    let topbarConfigurations = {
      options:
        showBackIcon == true
          ? [
            {
              icon: MenuIcon,
              text: "Dashboard",
              path: "/picstork/dashboard",
            },
          ]
          : null,
      user,
      type,
      mode: this.state.sidebarMode,
      picStorkHelp: true,
    };

    return user.username ? (
      <div className="wrapper">
        <ManageProjectAccess
          projectId={this.state.selectedMangeAccessProject}
          closeManageAccess={() => {
            this.setState({
              selectedMangeAccessProject: false,
              selectedProjectData: undefined,
            });
          }}
          senderData={user}
          propsData={this.state.selectedProjectData}
        />
        <SideBarNew
          config={sidebarConfigurations}
          showMainDashboardIcons={this.state.showBackIcon}
          parentSidebarSwitch={this.parentSidebarSwitch}
        />
        <div
          className="right-content"
          onClick={() => {
            this.setState((state) => ({
              ...state,
              sidebarMode: "shrunk",
            }));
          }}
        >
          <TopBarNew config={topbarConfigurations} />

          <div
            className="main-content"
            style={{
              background: "none",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <div
              style={{ display: "flex", gap: "20px", alignItems: "stretch" }}
            >
              <div
                style={{
                  width: "65%",
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                    fontWeight: 500,
                    color: "#18242D",
                  }}
                >
                  <p>Progress Monitoring</p>
                  {this.state.towersStatusCount?.total_installed > 0 && (
                    <Link
                      to="/picstork/total-projects"
                      style={{
                        color: "#0077cc",
                        fontSize: "13px",
                        fontWeight: "normal",
                        textDecoration: "underline",
                      }}
                    >
                      <span style={{ textDecoration: "underline" }}>
                        View More
                      </span>
                    </Link>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    marginTop: "10px",
                    flex: 1,
                    alignItems: "stretch",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "30%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "10px",
                    }}
                  >
                    <Circle
                      percent={
                        this.state.towersStatusCount
                          ?.installation_complete_percentage || 0
                      }
                      strokeWidth={8}
                      strokeColor="#87b6dfff"
                      strokeLinecap="round"
                      trailWidth={8}
                      trailColor="#E8E8E8"
                      backgroundColor="#C4DEF142"
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        textAlign: "center",
                      }}
                    >
                      <h4
                        style={{
                          fontWeight: "bold",
                          marginBottom: "4px",
                          fontSize: "24px",
                          color: "#333",
                        }}
                      >
                        {this.state.towersStatusCount
                          ?.installation_complete_percentage || 0}
                        %
                      </h4>
                      <div
                        style={{
                          color: "#18242D",
                          fontSize: "13px",
                          marginTop: "0px",
                          fontWeight: 500,
                        }}
                      >
                        Installation Complete
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      width: "70%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                        height: "100%",
                        padding: "10px",
                        height: "100%",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "stretch",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            borderRadius: "15px",
                            padding: "20px",
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            backgroundColor: "#C4DEF142",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItens: "center",
                                justifyContent: "center",
                                gap: "7px",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "12px",
                                  marginBottom: "0px",
                                }}
                              >
                                Total Towers
                              </p>
                              <h5 style={{ marginBottom: "0px" }}>
                                {this.state.towersStatusCount
                                  ?.total_installed || 0}
                              </h5>
                            </div>
                            <img src={TowerIcon} alt="Tower Icon" />
                          </div>
                        </div>
                        <div
                          style={{
                            borderRadius: "15px",
                            padding: "20px",
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            backgroundColor: "#C4DEF142",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItens: "center",
                                justifyContent: "center",
                                gap: "7px",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "12px",
                                  marginBottom: "0px",
                                }}
                              >
                                Inspection Completed
                              </p>
                              <h5 style={{ marginBottom: "0px" }}>
                                {this.state.towersStatusCount
                                  ?.completed_towers || 0}
                              </h5>
                            </div>
                            <img src={UpGraphIcon} alt="Tower Icon" />
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "stretch",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            borderRadius: "15px",
                            padding: "20px",
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            backgroundColor: "#C4DEF142",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItens: "center",
                                justifyContent: "center",
                                gap: "7px",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "12px",
                                  marginBottom: "0px",
                                }}
                              >
                                Inspection In Progress
                              </p>
                              <h5 style={{ marginBottom: "0px" }}>
                                {this.state.towersStatusCount
                                  ?.in_progress_towers || 0}
                              </h5>
                            </div>
                            <img src={DownGraphIcon} alt="Down Graph Icon" />
                          </div>
                        </div>
                        <div
                          style={{
                            borderRadius: "15px",
                            padding: "20px",
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            backgroundColor: "#C4DEF142",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItens: "center",
                                justifyContent: "center",
                                gap: "7px",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "12px",
                                  marginBottom: "0px",
                                }}
                              >
                                Inspection Pending
                              </p>
                              <h5 style={{ marginBottom: "0px" }}>
                                {this.state.towersStatusCount?.pending_towers ||
                                  0}
                              </h5>
                            </div>
                            <img src={YellowGraphIcon} alt="Tower Icon" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "45%",
                  borderRadius: "10px",
                  position: "relative",
                  overflow: "hidden",
                  zIndex: 1,
                }}
              >
                <TowerLocations />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "20px",
                marginTop: "20px",
                height: "18rem",
              }}
            >
              <div
                style={{
                  flex: 1,
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      margin: "0px",
                      padding: "0px",
                      fontWeight: 500,
                      color: "#18242D",
                    }}
                  >
                    Total Defects
                  </p>
                  {this.state.defects?.labels?.length > 0 && (
                    <Link
                      to={{
                        pathname: "/picstork/alldefects",
                        state: {
                          user: this.state.user,
                          sidebarMode: this.state.sidebarMode,
                        },
                      }}
                      style={{
                        fontSize: "0.85rem",
                        color: "#0077cc",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      <span style={{ textDecoration: "underline" }}>
                        View All
                      </span>
                    </Link>
                  )}
                </div>

                {this.state.defects?.labels?.length > 0 ? (
                  (() => {
                    let chartData = { ...this.state.defects };

                    const maxVisible = 5;
                    if (chartData.labels.length > maxVisible) {
                      const mainLabels = chartData.labels.slice(0, 4);
                      const mainData = chartData.datasets[0].data.slice(0, 4);
                      const mainColors =
                        chartData.datasets[0].backgroundColor.slice(0, 4);

                      const otherData = chartData.datasets[0].data
                        .slice(4)
                        .reduce((acc, val) => acc + val, 0);

                      mainLabels.push("Other");
                      mainData.push(otherData);
                      mainColors.push("#999999");

                      chartData = {
                        labels: mainLabels,
                        datasets: [
                          {
                            ...chartData.datasets[0],
                            data: mainData,
                            backgroundColor: mainColors,
                          },
                        ],
                      };
                    }

                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                          marginTop: "10px",
                          height: "100%",
                        }}
                      >
                        <div
                          style={{
                            position: "relative",
                            width: "65%",
                            height: "100%",
                          }}
                        >
                          <Doughnut
                            data={chartData}
                            options={{
                              cutout: "70%",
                              spacing: 8,
                              plugins: { legend: { display: false } },
                              maintainAspectRatio: false,
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              fontSize: "20px",
                              fontWeight: "bold",
                            }}
                          >
                            {chartData.datasets[0].data.reduce(
                              (a, b) => a + b,
                              0
                            )}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-around",
                            width: "35%",
                            height: "100%",
                            padding: "10px",
                            alignItems: "flex-start",
                          }}
                        >
                          {chartData.labels.map((label, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              <span
                                style={{
                                  width: "12px",
                                  height: "12px",
                                  borderRadius: "50%",
                                  background:
                                    chartData.datasets[0].backgroundColor[
                                    index
                                    ],
                                  display: "inline-block",
                                }}
                              ></span>
                              <span style={{ fontSize: "0.8rem" }}>
                                {label}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })()
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      marginTop: "70px",
                      color: "#666",
                    }}
                  >
                    <img
                      src={TransTowerIcon}
                      alt="Trans Icon"
                      style={{
                        width: "90px",
                        height: "90px",
                        marginBottom: "10px",
                      }}
                    />
                    <div>No Defects Found !</div>
                  </div>
                )}
              </div>

              <div
                style={{
                  flex: 1,
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      margin: "0px",
                      padding: "0px",
                      fontWeight: 500,
                      color: "#18242D",
                    }}
                  >
                    Defect Severity Breakdown
                  </p>
                  {this.state.severityFormated?.labels?.length > 0 && (
                    <Link
                      to={{
                        pathname: "/picstork/allseverities",
                        state: {
                          user: this.state.user,
                          sidebarMode: this.state.sidebarMode,
                          severity: this.state.severity,
                          sevarityFormatted: this.state.severityFormated,
                        },
                      }}
                      style={{
                        fontSize: "0.85rem",
                        color: "#0077cc",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      <span style={{ textDecoration: "underline" }}>
                        View All
                      </span>
                    </Link>
                  )}
                </div>

                {this.state.severityFormated?.labels?.length > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-end",
                        height: "80%",
                        overflow: "hidden",
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        {this.state.severityFormated?.labels?.length > 0 && (
                          <Doughnut
                            data={this.state.severityFormated}
                            options={{
                              rotation: -90,
                              circumference: 180,
                              cutout: "70%",
                              spacing: 8,
                              plugins: { legend: { display: false } },
                              maintainAspectRatio: false,
                            }}
                          />
                        )}
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "20px",
                        height: "20%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <span
                          style={{
                            width: "12px",
                            height: "12px",
                            borderRadius: "50%",
                            background: "#01B574",
                            display: "inline-block",
                          }}
                        ></span>
                        <span style={{ fontSize: "12px" }}>Low</span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <span
                          style={{
                            width: "12px",
                            height: "12px",
                            borderRadius: "50%",
                            background: "#322FC8",
                            display: "inline-block",
                          }}
                        ></span>
                        <span style={{ fontSize: "12px" }}>Medium</span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <span
                          style={{
                            width: "12px",
                            height: "12px",
                            borderRadius: "50%",
                            background: "#E73F76",
                            display: "inline-block",
                          }}
                        ></span>
                        <span style={{ fontSize: "12px" }}>High</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      marginTop: "70px",
                      color: "#666",
                    }}
                  >
                    <img
                      src={TransTowerIcon}
                      alt="Trans Icon"
                      style={{
                        width: "90px",
                        height: "90px",
                        marginBottom: "10px",
                      }}
                    />
                    <div>No Severity Found !</div>
                  </div>
                )}
              </div>

              <div
                style={{
                  flex: 1,
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  flexDirection: "column",
                }}
              >
                <RecentTowers />
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    activesubscription: (payload) => dispatch(activesubscription(payload)),
  };
};

const mapStateToProps = (state) => {
  return {
    SubscriptionData: state.subscription.subscriptionData,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AeroCaptureDashboard);
